import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  standalone: true,
  styleUrls: ['./overlay.component.css'],
})
export class OverlayComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
